import React, { useEffect, useRef, useState } from "react";
import PageTitle from "../../Module/pageTitle";
import LabelField from "../../Component/labelField";
import { useDispatch } from "react-redux";
import { getStudentData, getSubExam } from "../../Action/adminPanelAction";
import ImagePickerAndViewer from "../../Component/imagePickerAndViewer";
import { pdf_size_50MB, validateIsFileExcelType } from "../../Utils/validators";
import { showErrorSnackbar } from "../../Action/snackbarAction";
import { validateIsFileExcelTypeErrMsg } from "../../Utils/errorMsg";
import SubmitButton from "../../Component/SubmitButton";
import ExcelJS from "exceljs";
import { DownloadTableExcel } from "react-export-table-to-excel";

const ImportStudent = () => {
  const dispatch = useDispatch();
  const [selectedFile, setSelectedFile] = useState("");
  const [StudentDetailsArr, setStudentDetailsArr] = useState([]);
  const [StudentNameArr, setStudentNameArr] = useState([]);
  const tableRef = useRef(null);

  const handleFileUpload = async (e) => {
    e.preventDefault();
    if (!validateIsFileExcelType(e)) {
      dispatch(showErrorSnackbar(validateIsFileExcelTypeErrMsg));
      return;
    }
    if (e.target.files[0].size > pdf_size_50MB) {
      dispatch(showErrorSnackbar("File size should be less than 50 MB!!!"));
    } else {
      const file = e.target.files[0];
      setSelectedFile(file?.name);
      if (file) {
        const workbook = new ExcelJS.Workbook();
        const reader = new FileReader();

        reader.onload = async (e) => {
          const arrayBuffer = e.target.result;
          await workbook.xlsx.load(arrayBuffer);

          const worksheet = workbook.getWorksheet(1);
          let newArr = [];

          worksheet.eachRow((row, rowNumber) => {
            if (rowNumber === 1) return;

            let newRow = row.getCell(1).value?.richText
              ? row.getCell(1).value?.richText[0]?.text
              : row.getCell(1).value;
            console.log("newRow", newRow);
            newArr.push(newRow);
          });
          setStudentNameArr(newArr);
        };
        reader.readAsArrayBuffer(file);
      }
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const reqBody = {
      users: StudentNameArr,
    };
    dispatch(
      getStudentData(reqBody, (resp) => {
        if (resp) {
          setSelectedFile("");
          setStudentNameArr([]);
          setStudentDetailsArr(resp?.data);
        }
      })
    );
  };
  const validation = () => {
    return selectedFile === "";
  };
  const renderForm = () => {
    return (
      <form className="formWidth col-md-12" onSubmit={handleSubmit}>
        <div className="d-flex w-100">
          <div className="d-flex align-items-center">
            <LabelField labelName={"Upload Excel"} />
            <ImagePickerAndViewer
              labelName={"Upload Sample EXCEL"}
              // value={excelFile}
              handleChange={(e) => handleFileUpload(e)}
              htmlFor={`photo-upload`}
              doctype={"excel"}
              removelabel={true}
              selectedPDF={selectedFile}
              isRequired={true}
            />
            <label className="label">
              {selectedFile ? selectedFile : "Sample Excel"}
            </label>
          </div>
          <div>
            <SubmitButton name="Import" validations={validation()} />
          </div>
          {StudentDetailsArr?.length > 0 ? (
            <div className="d-flex mb-2 align-items-center col-md-3 justify-content-end">
              <DownloadTableExcel
                filename="student_details"
                sheet="Student Count"
                currentTableRef={tableRef.current}
              >
                <button className="btn btn-outline-primary rounded-pill py-1">
                  Export Details
                </button>
              </DownloadTableExcel>
            </div>
          ) : null}
        </div>
      </form>
    );
  };
  const renderTable = () => {
    return (
      <div className="col-12 formWidth" ref={tableRef}>
        <table className="w-100">
          <thead>
            <tr>
              <th>Sr.No.</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Mobile No</th>
            </tr>
          </thead>
          {StudentDetailsArr?.length > 0 ? (
            <tbody>
              {StudentDetailsArr?.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.firstName}</td>
                    <td>{item?.lastName}</td>
                    <td>{item?.mobileNo ? item?.mobileNo?.toString() : "-"}</td>
                  </tr>
                );
              })}
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td>No record found.</td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
    );
  };

  return (
    <div className="contentBox">
      <PageTitle name={"IMPORT STUDENT"} />
      <div className="formDiv">
        {renderForm()}
        {renderTable()}
      </div>
    </div>
  );
};

export default ImportStudent;
